import { ref } from 'vue'

export function useNotifications() {
  const notifications = ref([])

  const setNotification = (notification) => {
    notifications.value.push(notification)
    setTimeout(() => {
      removeNotification(notification)
    }, 8000)
  }

  const removeNotification = (notification) => {
    const index = notifications.value.indexOf(notification)
    if (index !== -1) {
      notifications.value.splice(index, 1)
    }
  }

  return {
    notifications,

    setNotification,
    removeNotification
  }
}
